// extracted by mini-css-extract-plugin
export default {"container":"Testimony_container__DqdEQ","content":"Testimony_content__qbMpL","cardContainer":"Testimony_cardContainer__ZeFzY"};